import { createContext } from 'react';
const defaultContextValue = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    redirectToState: () => { },
};
export const WidgetContext = createContext(defaultContextValue);
